import { Button } from '@/features/button';
import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import { Modal } from '@/features/modal';
import { useNavigateLogin } from '@/app/_utils/session/use-navigate-login';
interface Props {
  isOpen: boolean;
  handleClose: () => void;
}
export default function UserOrderModal({
  isOpen,
  handleClose
}: Props) {
  const {
    isMobile
  } = useMobileDetect();
  const navigateLogin = useNavigateLogin();
  return <Modal handleClose={handleClose} isOpen={isOpen} title='پیگیری سفارش' width='w-full lg:w-[508px]' data-sentry-element="Modal" data-sentry-component="UserOrderModal" data-sentry-source-file="user-order-modal.tsx">
            <p className='mb-6 mt-2 text-body-14 text-text-black lg:mt-3 lg:text-body-16'>
                برای پیگیری سفارش، لطفا ابتدا وارد شوید.
            </p>
            <Button graphicStyle='filled' size={isMobile ? 'medium' : 'large'} onClick={() => navigateLogin(false, '/profile/orders')} className='mx-auto' data-sentry-element="Button" data-sentry-source-file="user-order-modal.tsx">
                ورود به حساب کاربری
            </Button>
        </Modal>;
}